import moment from 'moment';

class CreatePocModalController {
  constructor($scope, $uibModalInstance, $rootScope, $http) {
    "ngInject";
    this.name = 'CreatePocModal';

    $scope.poc = {
      role: '',
      name: '',
      email: '',
      phone: '',
      notes: ''
    }

    // Validation function: Role, Name, and (phone OR email) are required
    $scope.isFormValid = function() {
      const roleValid = $scope.poc.role && $scope.poc.role.trim() !== '';
      const nameValid = $scope.poc.name && $scope.poc.name.trim() !== '';
      
      // At least one of phone or email must be provided
      const phoneValue = $scope.poc.phone ? $scope.poc.phone.trim() : '';
      const emailValue = $scope.poc.email ? $scope.poc.email.trim() : '';
      const contactValid = phoneValue !== '' || emailValue !== '';
      
      return roleValid && nameValid && contactValid;
    }

    let self = this;
    $scope.addPoc = function () {
      if (!$scope.isFormValid()) {
        return;
      }

      // Clean up the data before sending
      // Map 'role' to 'type' for backend compatibility
      const pocData = {
        type: $scope.poc.role.trim(), // Backend expects 'type'
        role: $scope.poc.role.trim(), // Also include 'role' for frontend
        name: $scope.poc.name.trim(),
        email: $scope.poc.email ? $scope.poc.email.trim() : null,
        phone: $scope.poc.phone ? $scope.poc.phone.trim() : null,
        notes: $scope.poc.notes ? $scope.poc.notes.trim() : null
      };

      $uibModalInstance.success(pocData);
    }

    $scope.cancel = function () {
      $uibModalInstance.dismiss();
    }

  }
}

export default CreatePocModalController;




// WEBPACK FOOTER //
// ./client/pages/admin/customer-details/modals/createPocModal/createPocModal.controller.js